import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';
import { useAuthContext } from '@providers/AuthProvider';

type TProps = {
  currentTab: string;
  setCurrentTab: (value: 'All Jobs' | 'Assigned To Me') => void;
};

export const TabSwitcher = ({ currentTab, setCurrentTab }: TProps) => {
  const { organization } = useAuthContext();

  if (!['all', 'assignedAndUnassigned'].includes(String(organization?.permissions?.viewJobs))) {
    return null;
  }

  return (
    <HeaderSwitchWrapper key="tabSwitcher">
      <SwitchButton active={currentTab === 'All Jobs'} onClick={() => setCurrentTab('All Jobs')}>
        All Jobs
      </SwitchButton>
      <SwitchButton active={currentTab === 'Assigned To Me'} onClick={() => setCurrentTab('Assigned To Me')}>
        Assigned To Me
      </SwitchButton>
    </HeaderSwitchWrapper>
  );
};
